const ABBR_DEFAULT_LENGTH = 15;

export function abbreviate(text: string, preferredLength?: number) {
	const length = preferredLength ? preferredLength : ABBR_DEFAULT_LENGTH;

	if (text.length > length + 3) {
		const prefix = text.slice(0, (length - 3) / 2);
		const suffix = text.slice(-(length - 3) / 2);
		return `${prefix}...${suffix}`;
	}

	return text;
}

export function abbreviateAddress(addressBech32: string) {
	const trimmed = addressBech32.replace('addr1', '').replace('addr_test1', '');
	return abbreviate(trimmed);
}

const convert = (from: any, to: any) => (str: string) =>
	Buffer.from(str, from).toString(to);
export const hexToUtf8 = convert('hex', 'utf8');

export const removeSpecialCharsAssetName = (assetName: string) => {
	return assetName.replace('\u0000\r�@', '');
};

export const unitToPolicyId = (unit: string) => unit.substring(0, 56);
export const unitToName = (unit: string) => unit.substring(56);
